import React, { useEffect, useRef, useState } from 'react';
import SectionShell from '../SectionShell';
import { useT } from '../../i18n/LanguageContext';

const DE = { question: 'Wie ist das möglich?', answer: 'Wir haben die Wertschöpfungskette neu gedacht.' };
const EN = { question: 'How is that possible?', answer: 'We have rethought the value chain.' };

/* Folie vor "Der traditionelle Weg": animiertes Fragezeichen,
   Klick 1 → Frage, Klick 2 → Antwort, Klick 3 → nächste Folie. */
export default function SectionWieMoeglich() {
  const { t, lang } = useT();
  const m = t.wieMoeglich || (lang === 'de' ? DE : EN);
  const [step, setStep] = useState(0);
  const shellRef = useRef(null);

  useEffect(() => {
    const node = shellRef.current;
    if (!node) return undefined;
    const onFragment = () => setStep((s) => Math.min(2, s + 1));
    node.addEventListener('fragment-advance', onFragment);
    return () => node.removeEventListener('fragment-advance', onFragment);
  }, []);

  return (
    <SectionShell id="wie-moeglich" centerContent>
      <div
        ref={shellRef}
        className="wm-shell"
        data-fragments-remaining={2 - step}
        data-testid="wie-moeglich-shell"
      >
        <div className="wm-mark font-display" aria-hidden="true">?</div>
        <h2 className={`wm-question font-display ${step >= 1 ? 'wm-visible' : ''}`} data-testid="wm-question">
          {m.question}
        </h2>
        <p className={`wm-answer font-display ${step >= 2 ? 'wm-visible' : ''}`} data-testid="wm-answer">
          {m.answer}
        </p>
      </div>
    </SectionShell>
  );
}
